import Slide from "@mui/material/Slide";
import React, {useState} from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import TextField from "@mui/material/TextField";
import PageWrapper from "../utils/PageWrapper";
import ResponsiveStack from "../utils/responsive-stack";
import Button from "@mui/material/Button";
import {useAuth} from "oidc-react";
import {useDispatch} from "react-redux";
import {updateStudyNote} from "../../features/study-note/studyNoteAPI";
import {fetchStudyNotesAsync} from "../../features/study-note/studyNoteSlice";
import {fetchNotificationsAsync} from "../../features/notifications/notifcationSlice";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const StudyNoteFullInfo = ({ open, setOpen, note }) => {

    const auth = useAuth();
    const dispatch = useDispatch();

    const [editMode, setEditMode] = useState(false);
    const [notes, setNotes] = useState(note.note);
    const [title, setTitle] = useState(note.title);
    const [changesMade, setChangesMade] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleNotesChange = e => {
        setNotes(e.target.value);
        setChangesMade(true);
    }

    const handleTitleChange = e => {
        setTitle(e.target.value);
        setChangesMade(true);
    }

    const updateNotes = () => {
        if (title !== "" && notes !== "") {
            const body = {
                title: title,
                note: notes,
            }

            updateStudyNote(auth.userData.access_token, JSON.stringify(body), note.id)
                .then(_ => {
                    dispatch(fetchStudyNotesAsync(auth.userData.access_token));
                    dispatch(fetchNotificationsAsync(auth.userData.access_token));
                    setEditMode(false);
                    setChangesMade(false);
                    setOpen(false);
                })
                .catch(err => console.log(err));
        }
    }
    return (
        <div>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <>
                    <AppBar sx={{position: 'relative'}}>
                        <Toolbar>
                            <Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
                                {`${note.title}`}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                            >
                                <CloseIcon/>
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <div style={{ marginTop: '1rem'}}/>
                    <PageWrapper>
                        {
                            editMode ?
                                <>
                                    <TextField onChange={handleTitleChange} variant={"outlined"} value={title} />
                                    <TextField onChange={handleNotesChange} variant={"standard"} value={notes} multiline={true}/>
                                </> :
                                    <TextField onChange={handleNotesChange} variant={"standard"} value={note.note} disabled={!editMode} multiline={true}/>

                        }
                        <ResponsiveStack>
                            <Button color={!editMode ? 'primary' : "error"} onClick={() => setEditMode(!editMode)}>
                                {!editMode ? 'Edit' : 'Cancel'}
                            </Button>

                            {
                                changesMade && editMode ?
                                    <Button color={"success"} onClick={updateNotes}>
                                        update
                                    </Button>
                                    : null
                            }

                        </ResponsiveStack>
                    </PageWrapper>
                    </>
            </Dialog>
        </div>
    )
}
